import { useState } from "react";
import api from "../../utils/api";
// import UploadImage from "./UploadImage";

export default function AddContentOwner({ productId, onSuccess }) {
  const [artistName, setArtistName] = useState("");
  const [name, setName] = useState("");
  const [mobile, setMobile] = useState("");
  const [email, setEmail] = useState("");
  const [address, setAddress] = useState("");
  const [nric, setNric] = useState("");
  const [payment, setPayment] = useState("");
  const [preferredPayment, setPreferredPayment] = useState("");

  //   const [imageFile, setImageFile] = useState(null);
  //   const [imagePreview, setImagePreview] = useState(null);

  //   const handleImageSelect = (file) => {
  //     setImageFile(file);
  //     setImagePreview(URL.createObjectURL(file));
  //   };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!productId) {
      alert("Invalid product.");
      return;
    }

    if (
      !artistName ||
      !name ||
      !mobile ||
      !email ||
      !address ||
      !nric ||
      !payment ||
      !preferredPayment
    ) {
      alert("All fields are required.");
      return;
    }

    // const formData = new FormData();
    // formData.append("name", name);
    // formData.append("description", description);
    // formData.append("status", status);

    // if (imageFile) {
    //   formData.append("image", imageFile);
    // }

    try {
      const ContentOwnerData = {
        artistName,
        name,
        mobile,
        email,
        address,
        nric,
        payment,
        preferredPayment,
        productId,
      };
      await api.post("/contentOwners", ContentOwnerData, {
        withCredentials: true,
        // headers: { "Content-Type": "multipart/form-data" },
      });

      alert("Content Owner added successfully!");
      setArtistName("");
      setName("");
      setMobile("");
      setEmail("");
      setAddress("");
      setNric("");
      setPayment("");
      setPreferredPayment("");

      if (onSuccess) onSuccess();
    } catch (error) {
      console.error(error.response?.data || error.message);
      alert(error.response?.data?.message || error.message);
    }
  };

  return (
    <form
      onSubmit={handleSubmit}
      className="max-w-md mx-auto bg-white rounded-2xl shadow-sm border border-gray-200 p-6"
    >
      <h2 className="text-xl font-semibold text-gray-800 mb-6">
        Add Content Owner
      </h2>

      <div className="mb-5">
        <label className="block text-sm font-medium text-gray-600 mb-1">
          Artist Name
        </label>
        <input
          type="text"
          placeholder="Artist Name"
          value={artistName}
          onChange={(e) => setArtistName(e.target.value)}
          className="w-full rounded-lg border border-gray-300 px-3 py-2 text-gray-800
                 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
        />
      </div>

      <div className="mb-5">
        <label className="block text-sm font-medium text-gray-600 mb-1">
          Name
        </label>
        <input
          type="text"
          placeholder="Content Owner Name"
          value={name}
          onChange={(e) => setName(e.target.value)}
          className="w-full rounded-lg border border-gray-300 px-3 py-2 text-gray-800
                 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
        />
      </div>

      <div className="mb-5">
        <label className="block text-sm font-medium text-gray-600 mb-1">
          Mobile
        </label>
        <input
          type="text"
          placeholder="Mobile"
          value={mobile}
          onChange={(e) => setMobile(e.target.value)}
          className="w-full rounded-lg border border-gray-300 px-3 py-2 text-gray-800
                 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
        />
      </div>

      <div className="mb-5">
        <label className="block text-sm font-medium text-gray-600 mb-1">
          Email
        </label>
        <input
          type="text"
          placeholder="Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className="w-full rounded-lg border border-gray-300 px-3 py-2 text-gray-800
                 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
        />
      </div>

      <div className="mb-5">
        <label className="block text-sm font-medium text-gray-600 mb-1">
          Address
        </label>
        <input
          type="text"
          placeholder="Address"
          value={address}
          onChange={(e) => setAddress(e.target.value)}
          className="w-full rounded-lg border border-gray-300 px-3 py-2 text-gray-800
                 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
        />
      </div>

      <div className="mb-5">
        <label className="block text-sm font-medium text-gray-600 mb-1">
          NRIC
        </label>
        <input
          type="text"
          placeholder="NRIC"
          value={nric}
          onChange={(e) => setNric(e.target.value)}
          className="w-full rounded-lg border border-gray-300 px-3 py-2 text-gray-800
                 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
        />
      </div>

      <div className="mb-6">
        <label className="block text-sm font-medium text-gray-600 mb-1">
          Payment
        </label>
        <select
          value={payment}
          onChange={(e) => setPayment(e.target.value)}
          className="w-full rounded-lg border border-gray-300 px-3 py-2 text-gray-800
                 bg-white focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
        >
          <option value="" disabled selected>
            Select Payment
          </option>
          <option value="KBZ Bank">KBZ Bank</option>
          <option value="AYA Bank">AYA Bank</option>
          <option value="CB Bank">CB Bank</option>
        </select>
      </div>

      <div className="mb-6">
        <label className="block text-sm font-medium text-gray-600 mb-1">
          Preferred Payment
        </label>
        <select
          value={preferredPayment}
          onChange={(e) => setPreferredPayment(e.target.value)}
          className="w-full rounded-lg border border-gray-300 px-3 py-2 text-gray-800
                 bg-white focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
        >
          <option value="" disabled selected>
            Select Payment
          </option>
          <option value="KBZ Bank">KBZ Bank</option>
          <option value="AYA Bank">AYA Bank</option>
          <option value="CB Bank">CB Bank</option>
        </select>
      </div>

      <button
        type="submit"
        className="w-full rounded-lg bg-green-500 py-2.5 text-white font-medium
               hover:bg-green-700 transition"
      >
        Add Content Owner
      </button>
    </form>
  );
}
